import React from "react";

interface IEmbedModal {
  parentClass?: string;
  url: string;
}

const EmbedModal = (props: IEmbedModal) => {
  // Convert regular YouTube link to embed format
  const getEmbedUrl = (url: string) => {
    const videoIdMatch = url.match(/(?:youtu\.be\/|v=)([a-zA-Z0-9_-]+)/);
    const videoId = videoIdMatch?.[1] || "";
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  return (
    <div
      className="iframeoutersection mt-3"
      style={{ position: "relative", paddingTop: "56.25%" }}
    >
      <iframe
        className={`iframeClasswatchlist ${props.parentClass}`}
        src={getEmbedUrl(props.url)}
        title="YouTube Video"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      ></iframe>
    </div>
  );
};

export default EmbedModal;
